import { Inject, Injectable } from '@angular/core';
import { HttpResponse } from '@angular/common/http';
import { isNil, omit } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

import { $frontendTypes } from './SalesOrders.frontend.types'

@Injectable({ providedIn: 'root' })
export class SalesOrders_reallocate_pick_task_flowService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }

  async run($inParams: { taskId: number, lotId: number, locationId: number, vendorLotId: number, currentPackagedAmount: number, updatedPackagedAmount: number }): Promise<{ reason?: string }> 
  {
    const $missingRequiredInParams = [];
    if (isNil($inParams.taskId)) {
      $missingRequiredInParams.push('\'taskId\'');
    }
    if (isNil($inParams.lotId)) {
      $missingRequiredInParams.push('\'lotId\'');
    }
    if (isNil($inParams.locationId)) {
      $missingRequiredInParams.push('\'locationId\'');
    }
    if (isNil($inParams.vendorLotId)) {
      $missingRequiredInParams.push('\'vendorLotId\'');
    }
    if (isNil($inParams.currentPackagedAmount)) {
      $missingRequiredInParams.push('\'currentPackagedAmount\'');
    }
    if (isNil($inParams.updatedPackagedAmount)) {
      $missingRequiredInParams.push('\'updatedPackagedAmount\'');
    }
    if ($missingRequiredInParams.length) {
    }
    let $url = `${environment.backendUrl}api/`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }

}

